<!--
  - Copyright (c) 2023. Haodong JU
  -->

<script>

export default {
  name: 'NextStepButton',
  props: {
    loading: {}
  }
}
</script>

<template>
  <div
    class="mt-4"
  >
    <v-btn
      :loading="loading"
      color="amber lighten-4 black--text"
      elevation="0"
      large
      @click="$emit('next')"
    >
      <slot>
        {{ $t('nextStep') }}
      </slot>
      <v-icon right>
        mdi-arrow-right
      </v-icon>
    </v-btn>
  </div>
</template>

<style scoped>

</style>
